import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaEscolaridade = () => {
  return (
    <MetricaBase
      titulo="Distribuição por Escolaridade"
      descricao="Análise da distribuição de colaboradores ativos por nível de escolaridade"
      endpoint="escolaridade"
      tipoDownload="escolaridade"
      cor="yellow"
    />
  );
};

export default MetricaEscolaridade;